export default "{\n    \"label\": \"Facility\"\n}\n"